// @ts-strict-ignore
export abstract class ExpressionNode {
  public declare parent: ExpressionNode;

  constructor(
    public left: ExpressionNode,
    public right: ExpressionNode,
  ) {}

  public abstract serialize(): any;

  public traverse<T, U extends ExpressionNode>(
    getValue: (node: U) => T,
    valueCondition: (node: U) => boolean,
    traverseCondition: (node: ExpressionNode) => boolean = () => true,
  ): T[] {
    return this.recursiveTraverse<T>(this, getValue, valueCondition, traverseCondition);
  }

  public find<T, U extends ExpressionNode>(getValue: (node: U) => T, valueCondition: (node: U) => boolean): T | null {
    return this.recursiveFind(this, getValue, valueCondition);
  }

  public assignParents(): ExpressionNode {
    this.recursiveAssignParents(this);
    return this;
  }

  private recursiveTraverse<T>(
    node: ExpressionNode,
    getValue: (node: ExpressionNode) => T,
    valueCondition: (node: ExpressionNode) => boolean,
    traverseCondition: (node: ExpressionNode) => boolean,
    values: T[] = [],
  ): T[] {
    if (node && traverseCondition(node)) {
      const value = valueCondition(node) ? [getValue(node)] : [];
      return [
        ...this.recursiveTraverse(node.left, getValue, valueCondition, traverseCondition, values),
        ...value,
        ...this.recursiveTraverse(node.right, getValue, valueCondition, traverseCondition, values),
      ];
    }

    return values;
  }

  private recursiveFind<T>(
    node: ExpressionNode,
    getValue: (node: ExpressionNode) => T,
    valueCondition: (node: ExpressionNode) => boolean,
  ): T | null {
    if (node) {
      if (valueCondition(node)) {
        return getValue(node);
      } else {
        return (
          this.recursiveFind(node.left, getValue, valueCondition) ||
          this.recursiveFind(node.right, getValue, valueCondition)
        );
      }
    }

    return null;
  }

  private recursiveAssignParents(node: ExpressionNode, parent: ExpressionNode = null): void {
    if (node) {
      node.parent = parent;
      this.recursiveAssignParents(node.left, node);
      this.recursiveAssignParents(node.right, node);
    }
  }
}
